import { render, staticRenderFns } from "./CouponEditTabInformation.vue?vue&type=template&id=13143b95&"
import script from "./CouponEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./CouponEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./CouponEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports